import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "clawback_token";

// Primary auth is the httpOnly cookie (sent via withCredentials). Safari / embedded
// iframes block third-party cookies, so we also carry the JWT as a Bearer fallback.
export const api = axios.create({ baseURL: API, withCredentials: true });

export function setAuthToken(token) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch { /* storage unavailable */ }
}

function getAuthToken() {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
}

api.interceptors.request.use((cfg) => {
  const token = getAuthToken();
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = err?.config?.url || "";
    if (err?.response?.status === 401 && !url.startsWith("/auth/")) {
      setAuthToken(null);
      window.dispatchEvent(new Event("clawback:unauthorized"));
    }
    if (err?.response?.status === 402) {
      window.dispatchEvent(new Event("clawback:paywall"));
    }
    return Promise.reject(err);
  },
);
